<script setup>
    
    import { storeToRefs } from 'pinia';

    import { useWindowStore } from '@/stores/window';
    const { scrollY, innerHeight } = storeToRefs(useWindowStore());

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const offscreen = ref(false);
    const isFixed = ref(false);
    const topbox = ref();

    watch(scrollY, (newScrollY) => {
        // Get the back-to-top element position
        const backToTopElement = topbox.value;
        const windowHeight = innerHeight.value;
        const backToTopPosition = backToTopElement?.getBoundingClientRect().top - windowHeight;
        // Set fixed class based on scroll position
        isFixed.value = (newScrollY >= windowHeight && backToTopPosition > 0);
        offscreen.value = (newScrollY <= windowHeight);
    });

</script>
<template>
    <div class="back-to-top" :class=" { 'is-fixed': isFixed, 'offscreen': offscreen }" ref="topbox">
        <button @click="scrollToTop" aria-label="Click to scroll to the top of the page">
            <MessSvg type="backToTopArrow" />
            <span>Back to top</span>
        </button>
    </div>
</template>

<style lang="scss">
    .back-to-top {
        position: relative;
        z-index: 1;

        &.is-fixed {
            button {
                position: fixed;
                opacity: 1;
                transform: translateY(0%);
                z-index: 9999;
            }
        }

        &.offscreen {
            button {
                position: fixed;
                opacity: 0;
                transition: 250ms ease-in-out;
                transform: translateY(100%);
            }
        }

        button {
            position: absolute;
            z-index: 1000;
            cursor: pointer;
            bottom: var(--box-padding-tb-m);
            left: 0;
            transition: 250ms ease-in-out;
            transform: translateY(0%);
            border-radius: 0 1.5625rem 1.5625rem 0;
            padding: 0.75rem 1.125rem 0.75rem 0.75rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            text-transform: uppercase;
            background-color: white;
            font-size: calc(12 / var(--base-fs) * 1rem);
            font-weight: 400;
            line-height: 0.75rem;
            letter-spacing: 0.06rem;

            svg {
                margin-top: -0.1875rem;
            }

            bottom: 1.375rem;
            left: 1.375rem;     
            border-radius: 1.5625rem;
            
            @media (min-width: $tablet) {
                padding: 0.75rem 1.125rem;
                bottom: 2.375rem;
                left: 2.375rem;   
            }

            @include hover {
                background-color: var(--teal);
                color: var(--cream);
            }
        }
    }
</style>